// BusinessRole interface removed - using UserRole with permissions instead

export interface RolePermission {
  id: string;
  name: string;
  description: string;
  category: PermissionCategory;
}

export type PermissionCategory = 
  | 'appointments'
  | 'services'
  | 'customers'
  | 'schedule'
  | 'reports'
  | 'settings';

export interface RoleFormData {
  name: string;
  description: string;
  permissions: string[]; // array of permission IDs
}

export interface RoleFilters {
  search?: string;
  isActive?: boolean;
  category?: string;
}

// Predefined permissions that can be assigned to roles
export const AVAILABLE_PERMISSIONS: RolePermission[] = [
  // Appointments
  { id: 'view_appointments', name: 'View Appointments', description: 'View all appointments', category: 'appointments' },
  { id: 'manage_appointments', name: 'Manage Appointments', description: 'Create, edit, and cancel appointments', category: 'appointments' },
  { id: 'approve_appointments', name: 'Approve Appointments', description: 'Approve or reject appointment requests', category: 'appointments' },
  
  // Services
  { id: 'view_services', name: 'View Services', description: 'View business services', category: 'services' },
  { id: 'manage_services', name: 'Manage Services', description: 'Create, edit, and delete services', category: 'services' },
  { id: 'assign_services', name: 'Assign Services', description: 'Assign services to professionals', category: 'services' },
  
  // Customers
  { id: 'view_customers', name: 'View Customers', description: 'View customer information', category: 'customers' },
  { id: 'manage_customers', name: 'Manage Customers', description: 'Edit customer information and preferences', category: 'customers' },
  
  // Schedule
  { id: 'view_schedule', name: 'View Schedule', description: 'View work schedules', category: 'schedule' },
  { id: 'manage_schedule', name: 'Manage Schedule', description: 'Set and modify work schedules', category: 'schedule' },
  { id: 'manage_availability', name: 'Manage Availability', description: 'Set availability and time off', category: 'schedule' },
  
  // Reports
  { id: 'view_reports', name: 'View Reports', description: 'View business reports and analytics', category: 'reports' },
  { id: 'export_reports', name: 'Export Reports', description: 'Export reports and data', category: 'reports' },
  
  // Settings
  { id: 'view_settings', name: 'View Settings', description: 'View business settings', category: 'settings' },
  { id: 'manage_settings', name: 'Manage Settings', description: 'Modify business settings and configuration', category: 'settings' },
  { id: 'manage_roles', name: 'Manage Roles', description: 'Create and manage professional roles', category: 'settings' },
  { id: 'manage_professionals', name: 'Manage Professionals', description: 'Invite and manage professionals', category: 'settings' },
];

// Note: Role permissions are now managed dynamically through the database
// No hardcoded role names are needed as the system is fully permission-based 